<template>
  <div class="swiper-mask-main" @click="closeEvent(2)">
    <div class="mask">
        <div class="close" :class="{'close1':widthId == 1,'close2':widthId == 2,'close3':widthId == 3}">
            <img loading="lazy"  src="../../../../static/img/newProductDetils/swiperClose.png" alt="" class="close-img" @click="closeEvent(2)">
        </div>
        <div :class="{'width1':widthId == 1,'width2':widthId == 2,'width3':widthId == 3}" class="widthId">
            <div class="swiper-container2">
                <div class="swiper-wrapper" @click.stop>
                    <div class="swiper-slide" v-for="(slide,index) in slides" :key="index">
                        <img loading="lazy"  
                            :src="slide.img ? slide.img : slide" 
                            alt="" 
                            @mouseover="handleMouseOver"
                            @mouseout="handleMouseOut"
                            >
                    </div>
                </div>
            </div>
        </div>
         <!-- 导航按钮 -->
        <div class="button" :class="{'button1':widthId == 1,'button2':widthId == 2,'button3':widthId == 3}" @click.stop>
            <div class="next common" ref="nextBtn" @mouseover="handleMouseOver" @mouseout="handleMouseOut"><img loading="lazy"  :src="next" alt=""></div>
            <div class="prev common" ref="prevBtn" @mouseover="handleMouseOver" @mouseout="handleMouseOut"><img loading="lazy"  :src="prev" alt=""></div>
        </div>
    </div>
  </div>
</template>
<script>
import 'swiper/dist/css/swiper.min.css'
import Swiper from 'swiper'
import next from '/static/img/newProductDetils/left1.png'
import prev from '/static/img/newProductDetils/right1.png'
export default {
    props:{
        swiperList:Array,
        swiperIndex:Number,
        widthId:Number
    },
    data() {
        return {
            slides: [],
            swiper: null,
            next:next,
            prev:prev,
        }
    },
    mounted() {
        this.initSwiper()
    //     if (/Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent)) {//判断是不是手机
    //     this.$refs.nextBtn.style.opacity = 1
    //     this.$refs.prevBtn.style.opacity = 1
    // }
    },
    watch:{
        swiperList:{
            handler(newVal){
                this.slides = newVal
            },
            deep:true,
            immediate:true
        }
    },
    methods:{
        initSwiper() {
            this.swiper = new Swiper('.swiper-container2', {
                // 配置参数
                pagination: '.swiper-pagination',
                slidesPerView: 1,
                paginationClickable: true,
                spaceBetween: 30,
                keyboardControl: true,
                nextButton: '.next',
                prevButton: '.prev',
                // 其他Swiper3参数...
                loop: true, // 循环模式
                initialSlide:this.swiperIndex,
                autoplay: 3000, // 自动播放（ms）
            })
        },
        closeEvent(){
           this.$emit('childCloseEvent',false)
        },
        handleMouseOver() {
            // 显示按钮
            this.$refs.nextBtn.style.opacity = 1
            this.$refs.prevBtn.style.opacity = 1
        },
        handleMouseOut() {
            // 隐藏按钮
            this.$refs.nextBtn.style.opacity = 0
            this.$refs.prevBtn.style.opacity = 0
        },
    }
}
</script>


<style lang="scss" scoped>
@import '/style/phone/productDetailsSwiper/maskSwiper/maskSwiper.scss';
 .swiper-mask-main{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    .mask{
        width: 938px;
        height: 625.333px;
        flex-shrink: 0;
        aspect-ratio: 938.00/625.33;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
}
.width1{
    width: 85.5rem;
    height: 39.75rem;
}
.width2{
    width: 56.7rem;
    height: 33.75rem;
}
.width3{
    width: 57.3rem;
    height: 41.4rem;
}
// .widthId{
//     width: 58.625rem;
//     height: 39.396rem;
//     flex-shrink: 0;
//     aspect-ratio: 938.00/625.33;
// }
.swiper-container2 {
    width: 100%; 
    height: 100%; 
    position: relative;
    overflow: hidden;
}
.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  img{
    width: 100%;
    height: 100%;
  }
}
.button{
    // width: 66.25rem;
    display: flex;
    justify-content: space-between;
    position: absolute;
}
.common{
    width: 2.5625rem;
    height: 2.5625rem;
    bottom: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #fff;
    transition: opacity 0.3s ease;  /* 添加过渡效果 */
    img{
        width: 35%;
        height: 35%;
    }
}
.next{
    left: -1.9375rem;
}
.prev{
    right: -1.9375rem;
}
.close{
    display: flex;
    justify-content: flex-end;
    width: 58.625rem;
}
.close1{
    width: 85.5rem;
}
.close2{
    width: 56.7rem;
}
.close3{
   width: 57.3rem;
}
.button1{
    width: 94.375rem;
}
.button2{
    width: 65.575rem;
}
.button3{
     width: 66.175rem;
}
.close-img{
    width: 1.625rem;
    height: 1.625rem;
    margin-bottom: 1.4375rem;
}
</style>